export default __webpack_public_path__ + "static/media/infobundel_herdenkingsstukken.0d9e1b8a.pdf";